import React from "react";
import { LogoPColor } from "../../../../general/assets/assets";
import DurationSession from "./DurationSession";

export default function HeaderOnSesssion({ title, sub }) {
  return (
    <div className="flex">
      <div className="flex justify-center items-center pl-2">
        <LogoPColor className="h-10" />
      </div>
      <div className="text-white  p-2 flex flex-col justify-start items-start">
        <h1 className="text-lg font-medium">{title}</h1>
        <p>
          {sub} | <DurationSession />
        </p>
      </div>
    </div>
  );
}
